
import _ from "lodash";
import { Options, Vue } from "vue-class-component";
import Header from "@/components/Header.vue";
import Module from "@/components/Module.vue";
import ApiService from "../services/ApiService";
import { wrapper } from "../utils/wrapper";
import { useStore } from "vuex";
import StorageService from "@/services/StorageService";
import { closePage, openPage } from "@/utils/patientLoggerPage";

@Options({
  components: {
    Header,
    Module
  }
})
export default class Modules extends Vue {
  viewName = "Modules";
  patientLoggerPageId: number | undefined;
  private storageService = new StorageService();
  private apiService = new ApiService();
  globalStore = useStore();
  user: any = null;
  treatmentSet = false;
  treatmentId: any = null;
  activeModuleId: any = null;

  // local modules array
  modules: any[] = [];
  isLoading = false;

  async created() {
    this.user = this.storageService.getUser();
    this.isLoading = true;
    await this.getModules();
    this.isLoading = false;
  }

  async mounted() {
    this.patientLoggerPageId = await openPage(
      this.viewName,
      this.user.patientsId
    );
  }

  async beforeUnmount() {
    if (this.patientLoggerPageId && this.storageService.getUser()) {
      await closePage(this.patientLoggerPageId, this.user.patientsId);
    }
  }

  async getModules() {
    const treatmentResponse = await wrapper(
      this.apiService.getTreatment(this.user.patientsId)
    );

    if (treatmentResponse.error) {
      console.error("get modules error ", treatmentResponse.error);
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.MODULES.GET_TREATMENT.FAILED.TITLE"),
        text: this.$t("ALERTS.MODULES.GET_TREATMENT.FAILED.TEXT")
      });
      return;
    }

    if (
      !treatmentResponse.data ||
      !Object.entries(treatmentResponse.data).length
    ) {
      this.treatmentSet = false;
      return;
    }

    const treatmentId = treatmentResponse.data.id;
    const treatmentsModules = treatmentResponse.data.treatmentsModules || [];
    const moduleOrder = [];
    const orderedModules = [];

    const modulesResponse = await wrapper(
      this.apiService.getModules(this.user.patientsId, treatmentId)
    );

    if (modulesResponse.error) {
      console.error("get current module error ", modulesResponse.error.data);
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.MODULES.GET.CURRENT.FAILED.TITLE"),
        text: this.$t("ALERTS.MODULES.GET.CURRENT.FAILED.TEXT")
      });
      return;
    }

    let modules = modulesResponse.data;

    if (!modules) {
      console.error("No data from module response ", modules);
      this.globalStore.commit("open", {
        type: "danger",
        title: this.$t("ALERTS.MODULES.GET.CURRENT.FAILED.TITLE"),
        text: this.$t("ALERTS.MODULES.GET.CURRENT.FAILED.TEXT")
      });
      return;
    }

    for (const treatmentModule of treatmentsModules) {
      moduleOrder.push(treatmentModule.modulesId);
    }

    for (const order of moduleOrder) {
      for (const module of modules) {
        if (module.id == order) {
          orderedModules.push(module);
        }
      }
    }

    // adds the module state to the modules
    modules = orderedModules.map((m: any) => {
      return {
        ...m,
        // adds the latest module state, the last one in the list
        state: _.sortBy(m.modulesStates || [], (m: any) => m.createdAt).pop()
      };
    });

    for (const treatmentModule of treatmentsModules) {
      let isEnabled = true;

      // if the module has a dependency
      if (treatmentModule.dependencyOf) {
        const dependency = treatmentsModules.find(
          (t: any) => t.id == treatmentModule.dependencyOf
        );

        if (dependency) {
          const dependencyModule = modules.find(
            (m: any) => m.id == dependency.modulesId
          );

          // we check if the dependency is finished
          isEnabled = !!dependencyModule?.state?.finished;
        }
      }

      // adds the enabled boolean field in the module object
      modules.find(
        (m: any) => m.id == treatmentModule.modulesId
      ).enabled = isEnabled;

      for (const m of modules) {
        if (m.state.attempts < 1) {
          m.disallowed = true;
          m.enabled = false;
        } else {
          m.disallowed = false;
        }
      }
    }

    this.modules = modules;
    this.treatmentSet = true;
  }
}
